import { render } from "./as-tags.vue?vue&type=template&id=a3315f06&scoped=true&ts=true"
import script from "./as-tags.vue?vue&type=script&lang=ts"
export * from "./as-tags.vue?vue&type=script&lang=ts"

import "./as-tags.vue?vue&type=style&index=0&id=a3315f06&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3315f06"]])

export default __exports__